import React, { useCallback } from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { motion, AnimatePresence } from 'framer-motion';
import { useToolbarState, useSetReloading } from '../../../contexts/ToolbarContext';

const transition = { duration: 0.2, ease: [0.4, 0, 0.2, 1] as const };

const HeaderReloadButtonInner: React.FC = () => {
  const {
    onReload,
    reloadDisabled,
    reloadDisabledReason,
    loading,
  } = useToolbarState();
  const setReloading = useSetReloading();

  const handleClick = useCallback(async () => {
    if (!onReload) return;
    setReloading(true);
    try {
      await onReload();
    } finally {
      setReloading(false);
    }
  }, [onReload, setReloading]);

  if (!onReload) return null;

  const disabled = reloadDisabled || loading;
  const tooltipTitle = reloadDisabled
    ? (reloadDisabledReason || 'Недоступно')
    : 'Обновить данные';

  return (
    <AnimatePresence>
      <motion.div
        key="header-reload"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        transition={transition}
      >
        <Tooltip title={tooltipTitle} placement="bottom">
          <button
            className={`header-button ${loading ? 'header-button--spinning' : ''}`}
            onClick={handleClick}
            disabled={disabled}
            type="button"
            aria-label="Обновить данные"
            data-tour-id="reload-button"
          >
            <ReloadOutlined style={{ fontSize: 16, color: 'rgba(255,255,255,0.85)' }} />
          </button>
        </Tooltip>
      </motion.div>
    </AnimatePresence>
  );
};

export const HeaderReloadButton = React.memo(HeaderReloadButtonInner);
